import React, { useEffect, useState } from 'react'
import ListGroup from '../../userPages/partials/ListGroup'
import UserHero from '../../userPages/partials/UserHero'
import { FaFrownOpen } from "react-icons/fa";
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { FaEye } from "react-icons/fa";
// import { useLocation } from "react-router-dom";
import { MdDeleteForever } from "react-icons/md";


export default function Booking() {
    let [data, setData] = useState([])
    let { _id } = useParams()


    async function deleteData(_id) {
        if (window.confirm("Are You Sure to Delete that Item :")) {

            let response = await fetch(`/api/booking/` + _id, {
                method: "DELETE",
                headers: {
                    "content-type": "application/json"
                },

            })
            response = await response.json()

            if (response.result === "Done") {
                toast.success("Deleted SuccessFully")
                setData(response)
            }
        }
    }

    async function getApiData() {
        let response = await fetch("/api/booking", {
            method: "GET",
            headers: {
                "content-type": "application/json",

            }
        })

        let data = await response.json();

        if (data.result === "Done") {


            const filteredData = data.data.filter(item => {
                return !(item.paymentStatus?.toLowerCase().trim() === "pending" && item.paymentMode?.toLowerCase().trim() === "net banking");

            });


            console.log(filteredData);
            setData(filteredData);
        } else {
            setData([]);
        }
    }


    useEffect(() => {
        getApiData()
    }, [])
    return (
        <>
            <UserHero />
            <div className="container">
                <div className="row my-3">

                    <ListGroup />

                    <div className="col-md-8">
                        <h1 className=' testimonials-h1 text-light text-center p-2' style={{ background: "#" }}>Booking Table </h1>
                        <div className="table-responsive">
                            {
                                data.length ?

                                    <table className='table table-bordered responsive'>
                                        <thead>
                                            <tr>
                                                <th>id</th>
                                                <th>check In Date</th>
                                                <th>check out Date</th>
                                                <th>adult</th>
                                                <th>child</th>
                                                <th>Price/Night</th>
                                                <th>No. of Night</th>
                                                <th>Total Room</th>
                                                <th>Total</th>
                                                <th>Payment Status</th>
                                                <th>Transection Id</th>
                                                <th>Payment Mode</th>
                                                <th>Date</th>
                                                {/* <th>Show</th> */}
                                                <th>delete</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data.map((item, index) => {
                                                    return <tr key={index}>
                                                        <td>
                                                            {item._id}</td>
                                                        <td>{item.checkIn}</td>
                                                        <td>{item.checkOut}</td>
                                                        <td>{item.adult}</td>
                                                        <td>{item.child}</td>
                                                        <td>{item.price}</td>
                                                        <td>{item.days}</td>
                                                        <td>{item.qty}</td>
                                                        <td>{item.total}</td>
                                                        <td>{item.paymentStatus}</td>
                                                        <td>{item.rppid}</td>
                                                        <td>{item.paymentMode}</td>
                                                        <td>{new Date(item.date).toLocaleDateString('en-GB')}</td>



                                                        <td>
                                                            <td>

                                                                <MdDeleteForever className='testimonil-table-btn' style={{ height: "30", width: "50", }} onClick={() => deleteData(item._id)} />

                                                            </td>
                                                        </td>
                                                    </tr>
                                                })
                                            }
                                        </tbody>
                                    </table>
                                    :
                                    <div className="not-testinomonil">
                                        <h3>Sorry! <FaFrownOpen />  User Booking Record Not Found!!</h3>

                                    </div>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
